import React, { useContext, useState, useEffect } from "react";
import { Box, Grid, Button } from '@mui/material';
import { styled } from '@mui/material/styles';
import { Link as RouterLink, useParams } from 'react-router-dom';
import { mainBlue, mainGray, blueButtonText } from "../GlobalUtilities/Styles";
import { LocationOn, Groups, Paid, KeyboardReturn, Map, CalendarMonth } from '@mui/icons-material';
import { DataContext } from "../context/DataContext";
import FormatDate from "../GlobalUtilities/FormatDate";

const MainBox = styled(Box)`
    margin-left: 10px;
    margin-right: 10px;
`;

const ReturnLink = styled('div')`
    display:flex;
    justify-content: flex-end;
    padding-right:45px;
    vertical-align:middle;
    margin-top:20px;
`;

const JobsLink = styled(RouterLink)`
    text-decoration: none;
    color: ${mainBlue};
`;

const ReturnIcon = styled(KeyboardReturn)`
    margin-bottom:-7px;
    padding-right:5px;
`;

const PostingHeader = styled('div')`
    text-align: left; 
    color:${mainBlue};
    font-size:1.5em;
    font-weight: bold;
`;

const PostingSubHeader = styled('div')`
    text-align: left; 
    color:${mainGray};
    font-size:1.1em;
    padding-top: 10px;

`;

const ButtonContainer = styled('div')`
    text-align: left;  
    padding:25px 0;
`;

const ApplyButton = styled(Button)`
    background-color: ${mainBlue};
    font-weight: bold;
`;

const ApplyLink = styled('a')`
    text-decoration: none;
    color: ${blueButtonText};
`;

const HtmlDescription = styled('div')`
    color:${mainGray};
    text-align: left;
`;

const DetailHeader = styled('div')`
    font-size:1.2em;
    font-weight:bold;
    color:${mainGray};
    border-bottom: solid 1px #ebebeb;
    padding-bottom:5px;
    text-align:left;
    width: 100%;
`;

const DetailSection = styled('div')`
    color:${mainGray};
    border-bottom: dotted 1px #ebebeb;
    padding:10px;
    text-align:left;
    width:100%;
    display: flex; /* Added */
    align-items: center; /* Added */
`;

const DetailedSectionNoBottom = styled('div')`
    color:${mainGray};
    padding:10px;
    text-align:left;
    width:100%;
    display: flex; /* Added */
    align-items: center; /* Added */
`;

const IconWrapper = styled('div')`
    color:${mainBlue};
    margin-right: 10px; /* Adjust spacing between icon and text */
`;
const IconWrapperBlank = styled('div')`
    color:#fff;
    margin-right: 10px; /* Adjust spacing between icon and text */
`;

const JobDetailSection = () => {
    const params = useParams();
    const { jobData } = useContext(DataContext);
    const [job, setJob] = useState(null);

    useEffect(() => {
        const urlJob = jobData.find(x => x.jobid == params.id);
        setJob(urlJob);
    }, [jobData]);

    if (!job) {
        return <div>Loading...</div>;
    }

    const JobURL = "https://CSS-AGRESERVES-TRN.INFORCLOUDSUITE.COM:443/sso/SSOServlet?_action=LOGINASSERT&_ssoOrigUrl=https%3A%2F%2Fcss-agreserves-trn.inforcloudsuite.com%3A443%2Fhcm%2FJobs%2Fform%2FJobPosting%255BJobPostingSet%255D%25281%252C1626%252C1%2529.CreateInProgressApplicationProcessActionForm%3FRequestCacheID%3D-19875747156892949481723826845531&_TKM=TODO-UI&_serviceName=HCM.HCMAPP.JOBS&_ssoTenant=AGRESERVES_TRN&_ssoval=O1jctRXJEHAnEz1brbsZKXWvsCo%3D";


    const JobApply = () => {
        //Make dynamic throughout
        const jobId = 1626;
        const response = fetch('https://css-agreserves-trn.inforcloudsuite.com/hcm/Jobs/action/JobPosting%5BJobPostingSet%5D%281%2C1626%2C1%29.CreateInProgressApplicationProcess?output=spec&form=JobPosting%5BJobPostingSet%5D%281%2C1626%2C1%29.JobPostingDisplay&csk.JobBoard=EXTERNAL&csk.HROrganization=1', {
            method: 'GET',
            credentials: 'include',
            mode: 'no-cors'
        })
        .then(response => {

            //Checking for 'Set-Cookie' in the headers
            console.log([...response.headers]);  // List all headers
            const cookies = response.headers.get('Set-Cookie');
            if (cookies) {
                console.log('Cookies set:', cookies);
            } else {
                console.log('No cookies set');
            }
        })
        .catch(error => console.error('Error:', error));
    };

    // const JobApply = async () => {
    //     //Make dynamic throughout
    //     const jobId = 1626;
    //     const response = await fetch(`https://css-agreserves-trn.inforcloudsuite.com/hcm/Jobs/form/JobPosting%5BJobPostingSet%5D%281%2C${jobId}%2C1%29.CreateInProgressApplicationProcessActionForm?csk.JobBoard=EXTERNAL&csk.HROrganization=1&action=_execute&list=JobPosting%5BJobBoardSet%5D(1%2CEXTERNAL%2C_niu_%2C_niu_%2C_niu_%2C_niu_).JobSearchCardViewList`, {
    //         method: 'POST',
    //         headers: {
    //             '_ssoclienttype': 'MSXML',
    //             'dnt': '1',
    //             'origini': 'https://css-agreserves-trn.inforcloudsuite.com',
    //             'pragma': 'no-cache',
    //             'priority': 'u=1',
    //             'referer': 'https://css-agreserves-trn.inforcloudsuite.com/hcm/Jobs/form/JobBoard%281,EXTERNAL%29.JobSearchCompositeForm?navigation=JobBoard%281,EXTERNAL%29.JobSearchCompositeFormNav&csk.JobBoard=EXTERNAL&csk.HROrganization=1'
    //         },
    //         body: `{"actionRequestArray":[{"dataView":{"viewAuditSecured":true,"resourceId":"JobPosting[JobPostingSet](1,1626,1)","busClassName":"JobPosting","navigations":[],"actionMeta":{},"contextProperties":{"context_prd_db_charset_prd_name":"UTF-16","context_prd_mode":""},"pagingUrls":{"reloadRecordUrl":"https://css-agreserves-trn.inforcloudsuite.com/hcm/Jobs/form/JobPosting[JobPostingSet](1,1626,1).CreateInProgressApplicationProcessActionForm?pageop=load&action=CreateInProgressApplicationProcess&list=JobPosting%5BJobBoardSet%5D%281%2CEXTERNAL%2C_niu_%2C_niu_%2C_niu_%2C_niu_%29.JobSearchCardViewList&list=JobPosting%5BJobBoardSet%5D(1%2CEXTERNAL%2C_niu_%2C_niu_%2C_niu_%2C_niu_).JobSearchCardViewList&csk.JobBoard=EXTERNAL&csk.HROrganization=1"},"viewFullAuditSecured":true,"formUrl":"https://css-agreserves-trn.inforcloudsuite.com/hcm/Jobs/form/JobPosting%5BJobPostingSet%5D%281%2C1626%2C1%29.CreateInProgressApplicationProcessActionForm?pagesize=1&list=JobPosting%5BJobBoardSet%5D%281%2CEXTERNAL%2C_niu_%2C_niu_%2C_niu_%2C_niu_%29.JobSearchCardViewList&csk.JobBoard=EXTERNAL&csk.HROrganization=1","name":"CreateInProgressApplicationProcess","action":"CreateInProgressApplicationProcess","actionIndexes":[11],"fields":{"HROrganization":{"size":4,"mutable":false,"stateValues":[{"label":"Investment Farms","value":"1"}],"value":"1","required":true},"JobPosting":{"symbolicKey":true,"size":4,"mutable":false,"value":1},"JobRequisition":{"size":9,"mutable":false,"value":1626,"required":true}},"representativeText":"Job Posting","status":"COMPLETED"},"confirmedMessageIds":[],"actionSpec":{"hasActionForm":true,"formName":"CreateInProgressApplicationProcessActionForm","name":"CreateInProgressApplicationProcess","index":18,"label":"Display Application","type":"FUNCTION","isCompletionNavigation":true}}]}`
    //     });

    //     const redirectMessage = await response.json();

    //     redirectMessage.then(x => {
    //         console.log("Done");
    //         console.log(x);
    //     });
    // };

    return (
        <MainBox sx={{ flexGrow: 1 }}>
            <Grid container>
                <Grid item md={9} xs={12} sx={{ order: { md: 1, xs: 2 } }}>
                    <ReturnLink>
                        <JobsLink to={"/"}>
                            <ReturnIcon />View All Jobs
                        </JobsLink>
                    </ReturnLink>
                    <PostingHeader>
                        {job.title}
                    </PostingHeader>
                    <PostingSubHeader>
                        {job.category} | {job.worktype}
                    </PostingSubHeader>
                    <PostingSubHeader>
                        Job Id: {job.jobid}
                    </PostingSubHeader>
                    <HtmlDescription dangerouslySetInnerHTML={{ __html: job.description }} />
                </Grid>
                <Grid item md={3} xs={12} sx={{ order: { md: 2, xs: 1 } }}>
                    <ButtonContainer>
                        <ApplyButton variant="contained" size="large">
                            <ApplyLink href={job.applyurl} target='_blank'>Apply Now</ApplyLink>
                        </ApplyButton>
                    </ButtonContainer>
                    {/* <ButtonContainer>
                        <ApplyButton variant="contained" size="large" onClick={JobApply}>
                            <ApplyLink>Apply Now</ApplyLink>
                        </ApplyButton>
                    </ButtonContainer> */}
                    <DetailHeader>Job Details</DetailHeader>
                    <DetailSection>
                        <IconWrapper><LocationOn /></IconWrapper>{job.location}
                    </DetailSection>
                    {job.countryname === "United States" && (
                        <>
                            <DetailSection>
                                <IconWrapper><Paid /></IconWrapper>{job.minpay} - {job.maxpay}
                            </DetailSection>
                        </>
                    )}
                    <DetailedSectionNoBottom>
                        <IconWrapper><CalendarMonth /></IconWrapper>Posted: < FormatDate rawDate={job.posted} />
                    </DetailedSectionNoBottom>
                    <DetailSection>
                        <IconWrapperBlank><CalendarMonth /></IconWrapperBlank>Closes: < FormatDate rawDate={job.closes} />
                    </DetailSection>
                    <DetailSection>
                        <IconWrapper><Groups /></IconWrapper>{job.division}
                    </DetailSection>
                </Grid>
            </Grid>
        </MainBox>
    )
}

export default JobDetailSection;